import { Link } from "react-router-dom";
import type { EvidenceRef } from "../../../api/playerReports";
import { trialUrl } from "./TrialTimeline";

export function EvidenceLinks({
  refs,
  comparison = false,
}: {
  refs: EvidenceRef[];
  comparison?: boolean;
}) {
  if (!refs.length) return null;
  const multipleSessions = new Set(refs.map((r) => r.session_id)).size > 1;
  return (
    <details className="report-evidence-links">
      <summary>
        {comparison
          ? "Grupo completo de comparación"
          : "Jugadas que respaldan esta lectura"}{" "}
        ({refs.length})
      </summary>
      <div>
        {refs.map((r) => (
          <Link
            key={`${r.session_id}-${r.trial_id}`}
            to={trialUrl({ session_id: r.session_id, id: r.trial_id })}
          >
            Jugada {r.number}{" "}
            <span className={multipleSessions ? "report-caption" : "sr-only"}>
              · sesión {r.session_id.slice(0, 8)}
            </span>
          </Link>
        ))}
      </div>
    </details>
  );
}
